import { render, staticRenderFns } from "./move-your-body-a45.vue?vue&type=template&id=efe3b800&"
import script from "./move-your-body-a45.vue?vue&type=script&lang=js&"
export * from "./move-your-body-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports